function notifyEditWA_P(payload) {
    var WA = `¡Hola ${payload.patient_first_name}!\nTu consulta ha sido modificada por el Dr. ${payload.doctor_name}\nRevisa los datos de tu nueva consulta a continuación\n\nNombre del paciente: ${payload.patient_name}\n${payload.date_time}\nEn clínica: ${payload.clinic_name}\nNo. Consulta: ${payload.consultation_id}`

    return WA
}

export {notifyEditWA_P}